import React from 'react';
import T from 'i18n-react';

import { Badge } from '@motorway/mw-highway-code';

import TimeCountdown from 'Components//shared/TimeCountdown/TimeCountdown';
import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';
import useSaleTimes from 'Utilities/hooks/useSaleTimes';

T.setTexts(require('Components/texts.json'));

const BiddingCountdown = () => {
	const { todaysSaleEndsAt } = useSaleTimes();

	return (
		<TimeCountdown countdownTime={todaysSaleEndsAt}>
			{({ timeLeft, timeString }) => (
				<Badge
					text={T.translate(`account.vehicleCard.${timeLeft ? 'endsIn' : 'saleEnded'}`, { value: timeString })}
					variant="primary"
					{...applyCypressData(cypressIds.lists.accountLiveSaleTimeTag)}
				/>
			)}
		</TimeCountdown>
	);
};

export default BiddingCountdown;
